export enum MessengerSendPaymentMethod {
  Online = 1,
  Manual = 2,
  Settled = 3,
}
